<app-icon-button (onClick)="showVideoHelpDialog()"></app-icon-button>
<div class="icons">
  <fa-icon class="youtube" [icon]="['fab', 'youtube']"></fa-icon>
  <fa-icon class="question-mark" icon="question"></fa-icon>
  <span class="number">{{ videoNumber }}</span>
</div>
